import createSagaMiddleware, {channel} from "redux-saga";
import {applyMiddleware, compose, createStore} from "redux";
import reducer from "./store/reducer";
import {bindActions} from "./store/actions";
import undoStoreEnhancer from "./store/undo";

const init = (initialState) => {
    const sagaMiddleware = createSagaMiddleware();
    const store = createStore(
        reducer,
        initialState || {},
        compose(
            applyMiddleware(sagaMiddleware),
            undoStoreEnhancer(),
        )
    );
    const actions = bindActions(store);
    const readyCh = channel();

    if (!initialState) {
        actions.init(window.location.host);
    }

    return { sagaMiddleware, store, actions, readyCh };
};

export default init;
